import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function LeadForm({ defaultBill, onSuccess, compact, testPrefix = "lead" }) {
  const [form, setForm] = useState({
    name: "", phone: "", email: "", city: "", type: "residencial", bill_value: "", message: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (defaultBill) setForm((f) => ({ ...f, bill_value: String(defaultBill) }));
  }, [defaultBill]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      toast.error("Preencha nome e telefone.");
      return;
    }
    setLoading(true);
    try {
      const payload = { ...form, bill_value: form.bill_value ? Number(form.bill_value) : null, email: form.email || null };
      await api.post("/leads", payload);
      toast.success("Recebemos seu contato! Vamos falar com você em breve.");
      setForm({ name: "", phone: "", email: "", city: "", type: "residencial", bill_value: "", message: "" });
      onSuccess?.(form);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full rounded-xl border border-border bg-white px-4 py-3 text-secondary placeholder:text-muted-foreground/70 focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary transition-all";

  return (
    <form onSubmit={submit} className="space-y-3" data-testid={`${testPrefix}-form`}>
      <div className="grid sm:grid-cols-2 gap-3">
        <input className={field} placeholder="Seu nome*" value={form.name} onChange={set("name")} data-testid={`${testPrefix}-name`} />
        <input className={field} placeholder="Telefone / WhatsApp*" value={form.phone} onChange={set("phone")} data-testid={`${testPrefix}-phone`} />
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <input className={field} placeholder="E-mail" type="email" value={form.email} onChange={set("email")} data-testid={`${testPrefix}-email`} />
        <input className={field} placeholder="Cidade" value={form.city} onChange={set("city")} data-testid={`${testPrefix}-city`} />
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <select className={field} value={form.type} onChange={set("type")} data-testid={`${testPrefix}-type`}>
          <option value="residencial">Residencial</option>
          <option value="comercial">Comercial / Empresa</option>
        </select>
        <input className={field} placeholder="Valor médio da conta (R$)" type="number" value={form.bill_value} onChange={set("bill_value")} data-testid={`${testPrefix}-bill`} />
      </div>
      {!compact && (
        <textarea className={field} rows={3} placeholder="Mensagem (opcional)" value={form.message} onChange={set("message")} data-testid={`${testPrefix}-message`} />
      )}
      <button
        type="submit"
        disabled={loading}
        className="w-full inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full bg-accent text-accent-foreground font-bold hover:brightness-105 active:scale-[0.98] transition-all disabled:opacity-60"
        data-testid={`${testPrefix}-submit-btn`}
      >
        {loading && <Loader2 size={18} className="animate-spin" />}
        Solicitar orçamento gratuito
      </button>
    </form>
  );
}
